export const BROKERAGE_SCHWAB = 'schwab';
export const BROKERAGE_TRADOVATE = 'tradovate';

export const TENANT_INVESTCEO = 'investceo';
export const TENANT_SMITHFIELD = 'smithfield';

export const TENANT_BROKERAGE_MAP = {
    [TENANT_INVESTCEO]: [BROKERAGE_TRADOVATE],
    [TENANT_SMITHFIELD]: [BROKERAGE_SCHWAB],
};